import { Component, OnInit, ViewChild } from '@angular/core';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { SubscriptionsService } from 'app/infrastructure/services/subscriptions.service';
import { SxSubscription } from 'app/infrastructure/model/classes/subscription.class';
import { ChannelsService } from 'app/infrastructure/services/channels.service';
import { RolesService } from 'app/infrastructure/services/roles.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from 'app/infrastructure/services/auth.service';
import { Location } from '@angular/common';
import { Channel } from 'app/infrastructure/model/interfaces/channel.interface';
import { TreeViewComponent } from 'app/helpers/components/treeView/treeView.component';
import { ActionConfig, TreeNodeView, TreeViewNode, SOCRole } from 'app/infrastructure/model/classes/soc.role.class';

@Component({
    selector: 'sx-soc-role',
    templateUrl: './soc-role.component.html',
    styleUrls: ['./soc-role.component.css']
})

export class SOCRoleComponent implements OnInit {
    role: SOCRole;
    selectedNodesData: string[] = [];
    uncheckedNodes: string[] = [];
    securityAttributesData: TreeViewNode<string>[];
    roleCode: string;
    mode: 'create' | 'edit' = 'create';

    @ViewChild('tree') tree: TreeViewComponent;

    constructor(
        private _subscriptionsService: SubscriptionsService,
        private _rolesService: RolesService,
        private _router: Router,
        private _location: Location,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService
    ) { }

    ngOnInit(): void {
        this._activatedRoute.params.subscribe((params: Params) => {
            this.roleCode = params.rolecode;

            if (this.roleCode) {
                this.mode = 'edit';
            }

            this.getRole(this.roleCode);
        });
    }

    getRole(roleCode: string) {
        this._rolesService
            .getSOCRole(roleCode)
            .then(data => this.handleData(data));
    }

    handleData(data: ActionConfig) {
        this.role = data.role;
        this.securityAttributesData = data.treeView.treeViewNodes;
        this.selectedNodesData = data.role.selectedActions || [];
    }

    back() {
        if (this.mode === 'create') {
            this._router.navigate(['../'], {relativeTo: this._activatedRoute});
        } else if (this.mode === 'edit') {
            this._router.navigate(['../../'], {relativeTo: this._activatedRoute});
        }

    }

    submit() {
        this.role.selectedActions = this.selectedNodesData;
        
        if (this.mode === 'create') {
            this._rolesService
                .createSOCRole(this.role)
                .then(data => this.back());
        } else if (this.mode === 'edit') {
            this._rolesService
                .editSOCRole(this.role)
                .then(data => this.back());
        }
    }

    onTreeNodeChecked(node: any) {
        // Cuando se chequea un nodo, guardamos su referencia en el array selectedNodesData.
        // En el caso de las carpetas, se guarda el folderId, en caso de los security attributes se guarda el codigo.
        if (node.key !== '' && !_.includes(this.selectedNodesData, node.key)) {
            this.selectedNodesData.push(node.key);
        }
    }

    onTreeNodeUnchecked(node: any) {
        if (this.selectedNodesData.length > 0) {
            // Al deseleccionar un nodo, se elimina del array selectedNodesData
            _.remove(this.selectedNodesData, function (item) {
                if (node.key !== '') {
                    return item === node.key;
                }
                return item === node.key;
            });
        }
    }

    updateCheckedNodes(nodes: any) {
        const self = this;
        _.each(nodes, function (node) {
            if (node.key) {
                if (node.state.checked && !_.includes(self.selectedNodesData, node.key)) {
                    self.selectedNodesData.push(node.key);
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/soc-role/create-rol/soc-role.component.ts